
import React from 'react';
import NavBar from "./NavBar/NavBar";
import Header from './Header/Header';
import Main from "./Main/Main";
import Footer from "./Footer-1/Footer";


function About() {
    return (
        <div>

            <NavBar />
            <Header />
            <Main />
            <Footer />
        </div>
    );
}

export default About;